import { httpGET, json } from './utils';
import { ACTIONS } from '../const';

import env from '../env';

const { PROXY } = env;

export const customerDomain = () => {
    let hostname = window.location.hostname;

    if (process.env.NODE_ENV !== 'production') {
        hostname = '127.0.0.1';
    }
    if (PROXY) {
        const tmp = new URL(PROXY);
        hostname = tmp.hostname;
    }

    return hostname;
};

export const getCustomer = () => dispatch => {
    return httpGET(`/api/v3/customer/?domain=${customerDomain()}`)
        .then(json)
        .then(({ objects: [data = {}] }) => {
            return dispatch({
                type: ACTIONS.SYNC_CUSTOMER,
                data,
            });
        });
};



// WEBPACK FOOTER //
// ./src/actions/customer.js